import { render, staticRenderFns } from "./DeleteCommunitySpace.vue?vue&type=template&id=bd99206e"
import script from "./DeleteCommunitySpace.vue?vue&type=script&lang=js"
export * from "./DeleteCommunitySpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports